import { Injectable, signal } from '@angular/core';

const TAMIL_DICT: { [key: string]: string } = {
  // Common Labels
  'Home': 'முகப்பு',
  'Master': 'மாஸ்டர்',
  'Child': 'குழந்தை',
  'Staff': 'பணியாளர்கள்',
  'Sponsor': 'ஸ்பான்சர்',
  'Church': 'தேவாலயம்',
  'Asset': 'சொத்து',
  'Activity': 'செயல்பாடு',
  'Payroll': 'சம்பள பட்டியல்',
  'Account': 'கணக்கு',
  'Multipurpose': 'பல்நோக்கு',
  'CC': 'சிசி',
  'User': 'பயனர்',
  'Role': 'பங்கு',
  'Location': 'இருப்பிடம்',
  'Office': 'அலுவலகம்',
  'General': 'பொது',
  'Notification Template': 'அறிவிப்பு வார்ப்புரு',
  'Homes/Project': 'வீடுகள்/திட்டம்',
  'Application Form': 'விண்ணப்ப படிவம்',
  'Attendance': 'வருகை',
  'Leave Application': 'விடுப்பு விண்ணப்பம்',
  'Bulk Amount': 'மொத்த தொகை',
  'Additions': 'கூடுதல்',
  'Deductions': 'கழிவுகள்',
  'Payroll Process': 'ஊதிய நடைமுறை',
  'Reminder': 'நினைவூட்டல்',
  'Holiday': 'விடுமுறை',
  'SI Forecast Report': 'SI முன்னறிவிப்பு அறிக்கை',
  'My Payslip': 'எனது ஊதியச் சீட்டு',
  'My Leave Quota': 'எனது விடுப்பு ஒதுக்கீடு',
  'Mark Complete': 'முழுமையானதாகக் குறிக்கவும்',
  'Created By:': 'உருவாக்கியவர்:',
  'Pending': 'நிலுவையில் உள்ளது',
  'Completed': 'முடிந்தது',
  'Days:': 'நாட்கள்:',
  'Total Staff:': 'மொத்த ஊழியர்கள்:',
  'Staff Name': 'ஊழியர் பெயர்',
  'Quick search...': 'விரைவான தேடல்...',
  'Present': 'தற்போது',
  'Yet': 'இன்னும்',
  'Half': 'பாதி',
  'Off': 'விடுப்பு',
  'By Date': 'தேதி வாரியாக',
  'By Month': 'மாதாந்திரம்',
  'Save Changes': 'மாற்றங்களை சேமிக்கவும்',
  'Saving...': 'சேமிக்கிறது...',
  'Hide': 'மறை',
  'Show': 'காண்பி',
  'Filters': 'வடிகட்டிகள்',
  'Profile': 'சுயவிவரம்',
  'Policies': 'கொள்கைகள்',
  'Email Logs': 'மின்னஞ்சல் பதிவுகள்',
  'Settings': 'அமைப்புகள்',
  'SI Calculator': 'SI கால்குலேட்டர்',
  'Logout': 'வெளியேறு',
  'Main': 'முக்கியமானது',
  'System': 'அமைப்பு',
  'Tools': 'கருவிகள்',
  'Get Data': 'தரவைப் பெறுக',
  'Export': 'ஏற்றுமதி',
  'Report': 'அறிக்கை',
  'Back': 'பின்னால்',
  'Any Not yet Marked': 'இன்னும் குறிக்கப்படவில்லை',
  'Any Present': 'ஏதேனும் உள்ளது',
  'Any Half Day': 'ஏதேனும் அரை நாள்',
  'None': 'எதுவுமில்லை',
  'Attendance Management': 'வருகை மேலாண்மை',
  'View Attendance': 'வருகையைப் பார்க்கவும்',
  'Sponsorship Allotment': 'ஸ்பான்சர்ஷிப் ஒதுக்கீடு',
  'Attendance Meta Info': 'வருகை மெட்டா தகவல்',
  'Mark all Present:': 'அனைவரையும் தற்போதையதாகக் குறிக்கவும்:',
  'Select': 'தேர்ந்தெடு',
  'Enter': 'உள்ளிடவும்',
  'Search': 'தேடு',
  'Loading data...': 'தரவை ஏற்றுகிறது...',
  'Region': 'மண்டலம்',
  'Zone': 'மண்டலம்',
  'Department': 'துறை',
  'Payroll Group': 'சம்பள பட்டியல் குழு',
  'Report Date': 'அறிக்கை தேதி',
  'Close/Back': 'மூடு/பின்னால்',
  'Done by': 'செய்தவர்',
  'on': 'தேதியில்',
  'NOTICE': 'அறிவிப்பு',
  'SI Calculation': 'SI கணக்கீடு',
  'Calculate': 'கணக்கிடு',
  'Year of Experience (Payroll):': 'அனுபவ ஆண்டு (ஊதியம்):',
  'years': 'ஆண்டுகள்',
  'Force To Present': 'கட்டாய வருகை',
  'Half Day': 'அரை நாள்',
  'weeks': 'வாரங்கள்',
  'Su': 'ஞாயிறு',
  'Mo': 'திங்கள்',
  'Tu': 'செவ்வாய்',
  'We': 'புதன்',
  'Th': 'வியாழன்',
  'Fr': 'வெள்ளி',
  'Sa': 'சனி',

  // Missing Menu Items
  'Add Child': 'குழந்தையைச் சேர்க்கவும்',
  'Add Report': 'அறிக்கையைச் சேர்க்கவும்',
  'Gift': 'பரிசு',
  'New Gift': 'புதிய பரிசு',
  'Yearly Update': 'ஆண்டு புதுப்பிப்பு',
  'New Staff': 'புதிய பணியாளர்கள்',
  'Staff Transfer': 'பணியாளர் இடமாற்றம்',
  'Monthly Report': 'மாதாந்திர அறிக்கை',
  'Add Monthly Report': 'மாதாந்திர அறிக்கையைச் சேர்க்கவும்',
  'Reports Stats': 'அறிக்கை புள்ளிவிவரங்கள்',
  'New Sponsorship': 'புதிய ஸ்பான்சர்ஷிப்',
  'Sponsorship': 'ஸ்பான்சர்ஷிப்',
  'Allotment': 'ஒதுக்கீடு',
  'Missionary Report': 'மிஷனரி அறிக்கை',
  'Dedication': 'அர்ப்பணிப்பு',
  'Donation': 'நன்கொடை',
  'View Church': 'தேவாலயத்தைப் பார்க்கவும்',
  'New Church': 'புதிய தேவாலயம்',
  'New Member': 'புதிய உறுப்பினர்',
  'View Member': 'உறுப்பினரைப் பார்க்கவும்',
  'Notice': 'அறிவிப்பு',
  'Bible Word': 'பைபிள் வார்த்தை',
  'New Activity': 'புதிய செயல்பாடு',
  'Income Entry': 'வருமான பதிவு',
  'Expense Entry': 'செலவு பதிவு',
  'Fin Report': 'நிதி அறிக்கை',
  'Church Donation': 'தேவாலய நன்கொடை',
  'Payment': 'கட்டணம்',
  'New Payment': 'புதிய கட்டணம்',
  'Progress Report': 'முன்னேற்ற அறிக்கை',
  'New Asset': 'புதிய சொத்து',
  'View Activity': 'செயல்பாட்டைப் பார்க்கவும்',
  'Application': 'விண்ணப்பம்',
  'New Application': 'புதிய விண்ணப்பம்',
  'Welfare Application': 'நலத்திட்ட விண்ணப்பம்',

  // Additional UI Labels
  'Select Sponsor': 'ஸ்பான்சரைத் தேர்ந்தெடுக்கவும்',
  'Click here to browse and select a sponsor for allotment': 'ஒதுக்கீட்டிற்கான ஸ்பான்சரை உலாவ மற்றும் தேர்ந்தெடுக்க இங்கே கிளிக் செய்யவும்',
  'Pending verification': 'சரிபார்ப்பு நிலுவையில் உள்ளது',
  'Amount': 'தொகை',
  'Category': 'வகை',
  'Status': 'நிலை',
  'Remarks': 'குறிப்புகள்',
  'Modification Req Pending': 'மாற்றக் கோரிக்கை நிலுவையில் உள்ளது',
  'Sponsorship Info': 'ஸ்பான்சர்ஷிப் தகவல்',
  'No. of Support': 'ஆதரவு எண்ணிக்கை',
  'Support Count': 'ஆதரவு எண்ணிக்கை',
  'Required': 'தேவை',
  'Invalid Amount': 'தவறான தொகை',
  'Invalid Number': 'தவறான எண்',
  'Sponsorship comes effect from *': 'ஸ்பான்சர்ஷிப் இதிலிருந்து அமலுக்கு வருகிறது *',
  'Month & Year': 'மாதம் & ஆண்டு',
  'Month of Changes is Required': 'மாற்றங்களின் மாதம் தேவை',
  'Ref ID': 'குறிப்பு ஐடி',
  'Name': 'பெயர்',
  'Active': 'செயலில் உள்ளது',
  'Edit': 'திருத்து',
  'Delete': 'அழி',
  'Withdraw': 'திரும்பப் பெறு',
  'Relived on': 'நிவாரணம் பெற்றது',
  'To delete': 'அழிக்க',
  'Associate Email': 'மின்னஞ்சலை இணைக்கவும்',
  'No CC Email': 'சிசி மின்னஞ்சல் இல்லை',
  'Remove': 'நீக்கு',
  '*maximum members only can select': '*அதிகபட்சம் உறுப்பினர்கள் மட்டுமே தேர்ந்தெடுக்க முடியும்',
  'Sponsorship has submitted for Verification You can\'nt make any changes': 'ஸ்பான்சர்ஷிப் சரிபார்ப்பிற்காக சமர்ப்பிக்கப்பட்டது நீங்கள் எந்த மாற்றமும் செய்ய முடியாது',
  'Sponsorship are Completed': 'ஸ்பான்சர்ஷிப் முடிந்தது',
  'Prev': 'முந்தைய',
  'Submit': 'சமர்ப்பி',
  'Save & Next': 'சேமி & அடுத்து',
  'Cancel': 'ரத்துசெய்',
  'Zone Name': 'மண்டல பெயர்',
  'Home Name': 'வீட்டு பெயர்',
  'Church Name': 'தேவாலய பெயர்',
  'Occupation': 'தொழில்',
  'Total': 'மொத்தம்',
  'Zone/Home': 'மண்டலம்/இல்லம்',
  'Process': 'செயல்முறை',
  'S/No.': 'வரிசை எண்',
  'Mobile': 'கைபேசி',
  'Email': 'மின்னஞ்சல்',
  'created': 'உருவாக்கப்பட்டது',
  'Action': 'செயல்',
  'status': 'நிலை',
  'Add Role': 'பங்கைச் சேர்',
  'Add New': 'புதியதைச் சேர்',
  'Search..': 'தேடு..',
  'Actions': 'செயல்கள்',
  'Reload Table': 'அட்டவணையை மீண்டும் ஏற்றவும்',
  'Please wait data fetching...': 'தரவு எடுக்கும் வரை காத்திருக்கவும்...',
  'No data found.': 'தரவு எதுவும் கிடைக்கவில்லை.',
  'Manage Permission': 'அனுமதியை நிர்வகிக்கவும்',
  'Make Inactive': 'செயலற்றதாக்கு',
  'Total Request': 'மொத்த கோரிக்கை',
  'Add': 'சேர்',
  'update': 'புதுப்பி',
  'New': 'புதியது',
  'To Delete': 'அழிக்க',
  'To Update': 'புதுப்பிக்க',
  'To Add': 'சேர்க்க',
  'Select Old Allotment': 'பழைய ஒதுக்கீட்டைத் தேர்ந்தெடுக்கவும்',
  'Child Type': 'குழந்தை வகை',
  'Home Child': 'வீட்டு குழந்தை',
  'MK Child': 'MK குழந்தை',
  'Role Management': 'பங்கு மேலாண்மை',
  'Close': 'மூடு',
  'Save': 'சேமி',
  'Credit': 'வரவு',
  'Debit': 'செலவு',
  'Balance': 'இருப்பு',
  'Fetching data...': 'தரவு எடுக்கப்படுகிறது...',
  'REGION Statistics': 'மண்டல புள்ளிவிவரங்கள்',
  'ZONE Statistics': 'மண்டல புள்ளிவிவரங்கள்',
  'CHURCH Statistics': 'தேவாலய புள்ளிவிவரங்கள்',
  '* All the sponsorship will be In active': '* அனைத்து ஸ்பான்சர்ஷிப்களும் செயலிழக்கப்படும்',
  'Search Staff': 'ஊழியர்களைத் தேடு',
  'Total Payroll Exp': 'மொத்த ஊதியச் செலவு',
  'Total Additional': 'மொத்தக் கூடுதல்',
  'Show All Church List': 'அனைத்து தேவாலயப் பட்டியலையும் காண்பி',
  'No fields added yet. Select from the top tags to add fields.': 'இன்னும் புலங்கள் எதுவும் சேர்க்கப்படவில்லை. புலங்களைச் சேர்க்க மேலே உள்ள குறிச்சொற்களிலிருந்து தேர்ந்தெடுக்கவும்.',
  'Flow Action': 'ஓட்ட செயல்',
  'Select Action Type': 'செயல் வகையைத் தேர்ந்தெடுக்கவும்',
  'Default Action:': 'இயல்புநிலை செயல்:',
  'Please Make sure all are Valid': 'தயவுசெய்து அனைத்தும் சரியாக இருப்பதை உறுதி செய்யவும்',
  'Manage Gift': 'பரிசை நிர்வகிக்கவும்',
  'Update ROle Details': 'பங்கு விவரங்களைப் புதுப்பிக்கவும்',
  'Add New Role': 'புதிய பங்கைச் சேர்க்கவும்',
  'Search Member to add': 'சேர்க்க உறுப்பினரைத் தேடு',
  'Search Staff to add as member': 'உறுப்பினராகச் சேர்க்க ஊழியரைத் தேடு',
  'Clear All': 'அனைத்தையும் அழி',
  'Manage Registration': 'பதிவை நிர்வகிக்கவும்',
  'Email Address:': 'மின்னஞ்சல் முகவரி:',
  'Mobile No:': 'கைபேசி எண்:',
  'Date Of Birth:': 'பிறந்த தேதி:',
  'Address:': 'முகவரி:',
  'Birth Date:': 'பிறந்த தேதி:',
  'Permanent Address:': 'நிரந்தர முகவரி:',
  'Family Image:': 'குடும்பப் படம்:',
  'Spouse Info': 'துணைவியார் தகவல்',
  'No Spouse Details': 'துணைவியார் விவரங்கள் இல்லை',
  'Others Info': 'இதர தகவல்கள்',
  'Comment': 'கருத்து',
  'Medical Info': 'மருத்துவ தகவல்',
  'Bank Details': 'வங்கி விவரங்கள்',
  'Support Documents': 'ஆதரவு ஆவணங்கள்',
  'Years Of Exp Payroll': 'ஊதியப் பட்டியலில் அனுபவ ஆண்டுகள்',
  'Years': 'ஆண்டுகள்',
  'Additional Experience': 'கூடுதல் அனுபவம்',
  '* All the designation and sponsorship will be': '* அனைத்து பதவிகளும் மற்றும் நிதியுதவிகளும்',
  'In active': 'செயலிழக்கப்படும்',
  'Staff is not active now': 'ஊழியர் இப்போது செயலில் இல்லை',
  'Loading notice data...': 'அறிவிப்புத் தரவு ஏற்றப்படுகிறது...',
  'Multilingual Content': 'பல்மொழி உள்ளடக்கம்',
  'Published': 'வெளியிடப்பட்டது',
  'Draft': 'வரைவு',
  'Title (English)': 'தலைப்பு (ஆங்கிலம்)',
  'Content (English)': 'உள்ளடக்கம் (ஆங்கிலம்)',
  'Targeting & Settings': 'இலக்கு மற்றும் அமைப்புகள்',
  'Save Notice': 'அறிவிப்பைச் சேமி',
  'Form Structure': 'படிவ அமைப்பு',
  'Fields': 'புலங்கள்',
  'Column:': 'நெடுவரிசை:',
  'Not Access to Approve this Child.': 'இந்தக் குழந்தையை அங்கீகரிக்க அனுமதி இல்லை.',
  'To select the Staff to allotment': 'ஒதுக்கீட்டிற்கு ஊழியரைத் தேர்ந்தெடுக்க',
  'Parent Aadhar': 'பெற்றோர் ஆதார்',
  'OR': 'அல்லது',
  'loading...': 'ஏற்றப்படுகிறது...',
  'Table of Contents': 'பொருளடக்கம்',
  'Select a Document to View': 'பார்க்க ஆவணத்தைத் தேர்ந்தெடுக்கவும்',
  'Policy': 'கொள்கை',
  'Select a section from the table of contents to begin reading.': 'படிக்கத் தொடங்க பொருளடக்கத்திலிருந்து ஒரு பகுதியைத் தேர்ந்தெடுக்கவும்.',
  'Email already exists': 'மின்னஞ்சல் ஏற்கனவே உள்ளது',
  'Aadhaar Number already exists': 'ஆதார் எண் ஏற்கனவே உள்ளது',
  'PAN Number already exists': 'பான் எண் ஏற்கனவே உள்ளது',
  'Mobile Number Exists': 'கைபேசி எண் ஏற்கனவே உள்ளது'
};

const HINDI_DICT: { [key: string]: string } = {
  // Common Labels
  'Home': 'होम',
  'Master': 'मास्टर',
  'Child': 'बच्चा',
  'Staff': 'कर्मचारी',
  'Sponsor': 'प्रायोजक',
  'Church': 'चर्च',
  'Asset': 'संपत्ति',
  'Activity': 'गतिविधि',
  'Payroll': 'पेरोल',
  'Account': 'खाता',
  'Multipurpose': 'बहुउद्देशीय',
  'CC': 'सीसी',
  'User': 'उपयोगकर्ता',
  'Role': 'भूमिका',
  'Location': 'स्थान',
  'Office': 'कार्यालय',
  'General': 'सामान्य',
  'Notification Template': 'अधिसूचना टेम्पलेट',
  'Homes/Project': 'घर/परियोजना',
  'Application Form': 'आवेदन पत्र',
  'Attendance': 'उपस्थिति',
  'Leave Application': 'छुट्टी का आवेदन',
  'Bulk Amount': 'थोक राशि',
  'Additions': 'अतिरिक्त',
  'Deductions': 'कटौती',
  'Payroll Process': 'पेरोल प्रक्रिया',
  'Reminder': 'अनुस्मारक',
  'Holiday': 'छुट्टी',
  'SI Forecast Report': 'SI पूर्वानुमान रिपोर्ट',
  'My Payslip': 'मेरी पेस्लिप',
  'My Leave Quota': 'मेरा अवकाश कोटा',
  'Mark Complete': 'पूर्ण चिह्नित करें',
  'Created By:': 'द्वारा बनाया गया:',
  'Pending': 'लंबित',
  'Completed': 'पूरा हुआ',
  'Days:': 'दिन:',
  'Total Staff:': 'कुल कर्मचारी:',
  'Staff Name': 'कर्मचारी का नाम',
  'Quick search...': 'त्वरित खोज...',
  'Present': 'वर्तमान',
  'Yet': 'अभी तक',
  'Half': 'आधा',
  'Off': 'बंद',
  'By Date': 'तारीख के अनुसार',
  'By Month': 'महीने के अनुसार',
  'Save Changes': 'परिवर्तन सुरक्षित करें',
  'Saving...': 'सहेज रहा है...',
  'Hide': 'छिपाएं',
  'Show': 'देखें',
  'Filters': 'फ़िल्टर',
  'Profile': 'प्रोफ़ाइल',
  'Policies': 'नीतियां',
  'Email Logs': 'ईमेल लॉग',
  'Settings': 'सेटिंग्स',
  'SI Calculator': 'SI कैलकुलेटर',
  'Logout': 'लॉग आउट',
  'Main': 'मुख्य',
  'System': 'सिस्टम',
  'Tools': 'उपकरण',
  'Get Data': 'தரவைப் பெறுக',
  'Export': 'निर्यात',
  'Report': 'रिपोर्ट',
  'Back': 'पीछे',
  'Any Not yet Marked': 'अभी तक चिह्नित नहीं',
  'Any Present': 'कोई भी उपस्थित',
  'Any Half Day': 'कोई भी आधा दिन',
  'None': 'कोई नहीं',
  'Attendance Management': 'उपस्थिति प्रबंधन',
  'View Attendance': 'उपस्थिति देखें',
  'Sponsorship Allotment': 'प्रायोजन आवंटन',
  'Attendance Meta Info': 'उपस्थिति मेटा जानकारी',
  'Mark all Present:': 'सभी को वर्तमान चिह्नित करें:',
  'Select': 'चुने',
  'Enter': 'दर्ज करें',
  'Search': 'खोज',
  'Loading data...': 'डेटा लोड हो रहा है...',
  'Region': 'क्षेत्र',
  'Zone': 'क्षेत्र',
  'Department': 'विभाग',
  'Payroll Group': 'पेरोल समूह',
  'Report Date': 'रिपोर्ट की तारीख',
  'Close/Back': 'बंद/पीछे',
  'Done by': 'द्वारा किया गया',
  'on': 'पर',
  'NOTICE': 'सूचना',
  'SI Calculation': 'SI गणना',
  'Calculate': 'गणना',
  'Year of Experience (Payroll):': 'अनुभव का वर्ष (पेरोल):',
  'years': 'वर्षों',
  'Force To Present': 'उपस्थिति के लिए मजबूर करें',
  'Half Day': 'आधा दिन',
  'weeks': 'सप्ताह',
  'Su': 'रवि',
  'Mo': 'सोम',
  'Tu': 'मंगल',
  'We': 'बुध',
  'Th': 'गुरु',
  'Fr': 'शुक्र',
  'Sa': 'शनि',

  // Missing Menu Items
  'Add Child': 'बच्चा जोड़ें',
  'Add Report': 'रिपोर्ट जोड़ें',
  'Gift': 'उपहार',
  'New Gift': 'नया उपहार',
  'Yearly Update': 'वार्षिक अपडेट',
  'New Staff': 'नया कर्मचारी',
  'Staff Transfer': 'कर्मचारी स्थानांतरण',
  'Monthly Report': 'मासिक रिपोर्ट',
  'Add Monthly Report': 'मासिक रिपोर्ट जोड़ें',
  'Reports Stats': 'रिपोर्ट आँकड़े',
  'New Sponsorship': 'नया प्रायोजन',
  'Sponsorship': 'प्रायोजन',
  'Allotment': 'आवंटन',
  'Missionary Report': 'मशीनरी रिपोर्ट',
  'Dedication': 'समर्पण',
  'Donation': 'दान',
  'View Church': 'चर्च देखें',
  'New Church': 'नया चर्च',
  'New Member': 'नया सदस्य',
  'View Member': 'सदस्य देखें',
  'Notice': 'सूचना',
  'Bible Word': 'बाइबल शब्द',
  'New Activity': 'नई गतिविधि',
  'Income Entry': 'आय प्रविष्टि',
  'Expense Entry': 'व्यय प्रविष्टि',
  'Fin Report': 'वित्त रिपोर्ट',
  'Church Donation': 'चर्च दान',
  'Payment': 'भुगतान',
  'New Payment': 'नया भुगतान',
  'Progress Report': 'प्रगति रिपोर्ट',
  'New Asset': 'नई संपत्ति',
  'View Activity': 'गतिविधि देखें',
  'Application': 'आवेदन',
  'New Application': 'नया आवेदन',
  'Welfare Application': 'कल्याण आवेदन',

  // Additional UI Labels
  'Select Sponsor': 'प्रायोजक चुनें',
  'Click here to browse and select a sponsor for allotment': 'आवंटन के लिए प्रायोजक ब्राउज़ करने और चुनने के लिए यहां क्लिक करें',
  'Pending verification': 'सत्यापन लंबित है',
  'Amount': 'रकम',
  'Category': 'श्रेणी',
  'Status': 'स्थिति',
  'Remarks': 'टिप्पणियाँ',
  'Modification Req Pending': 'संशोधन अनुरोध लंबित',
  'Sponsorship Info': 'प्रायोजन जानकारी',
  'No. of Support': 'समर्थन की संख्या',
  'Support Count': 'समर्थन गणना',
  'Required': 'आवश्यक',
  'Invalid Amount': 'अमान्य राशि',
  'Invalid Number': 'अमान्य संख्या',
  'Sponsorship comes effect from *': 'प्रायोजन प्रभावी होता है *',
  'Month & Year': 'महीना और साल',
  'Month of Changes is Required': 'परिवर्तन का महीना आवश्यक है',
  'Ref ID': 'संदर्भ आईडी',
  'Name': 'नाम',
  'Active': 'सक्रिय',
  'Edit': 'संपादन करें',
  'Delete': 'हटाएं',
  'Withdraw': 'वापस लें',
  'Relived on': 'कार्यमुक्त तिथि',
  'To delete': 'हटाने के लिए',
  'Associate Email': 'ईमेल संबद्ध करें',
  'No CC Email': 'कोई सीसी ईमेल नहीं',
  'Remove': 'निकालें',
  '*maximum members only can select': '*अधिकतम सदस्य ही चुन सकते हैं',
  'Sponsorship has submitted for Verification You can\'nt make any changes': 'सत्यापन के लिए प्रायोजन प्रस्तुत किया गया है आप कोई बदलाव नहीं कर सकते',
  'Sponsorship are Completed': 'प्रायोजन पूर्ण हो गया है',
  'Prev': 'पिछला',
  'Submit': 'प्रस्तुत करें',
  'Save & Next': 'सहेजें और अगला',
  'Cancel': 'रद्द करें',
  'Zone Name': 'जोन का नाम',
  'Home Name': 'घर का नाम',
  'Church Name': 'चर्च का नाम',
  'Occupation': 'व्यवसाय',
  'Total': 'कुल',
  'Zone/Home': 'जोन/होम',
  'Process': 'प्रक्रिया',
  'S/No.': 'क्रम संख्या',
  'Mobile': 'मोबाइल',
  'Email': 'ईमेल',
  'created': 'बनाया गया',
  'Action': 'कार्य',
  'status': 'स्थिति',
  'Add Role': 'भूमिका जोड़ें',
  'Add New': 'नया जोड़ें',
  'Search..': 'खोजें..',
  'Actions': 'कार्य',
  'Reload Table': 'तालिका को फिर से लोड करें',
  'Please wait data fetching...': 'कृपया डेटा प्राप्त करने की प्रतीक्षा करें...',
  'No data found.': 'कोई डेटा नहीं मिला।',
  'Manage Permission': 'अनुमति प्रबंधित करें',
  'Make Inactive': 'निष्क्रिय करें',
  'Total Request': 'कुल अनुरोध',
  'Add': 'जोड़ें',
  'update': 'अद्यतन',
  'New': 'नया',
  'To Delete': 'हटाने के लिए',
  'To Update': 'अद्यतन करने के लिए',
  'To Add': 'जोड़ने के लिए',
  'Select Old Allotment': 'पुराना आवंटन चुनें',
  'Child Type': 'बच्चे का प्रकार',
  'Home Child': 'होम चाइल्ड',
  'MK Child': 'एमके चाइल्ड',
  'Role Management': 'भूमिका प्रबंधन',
  'Close': 'बंद करें',
  'Save': 'सहेजें',
  'Credit': 'क्रेडिट',
  'Debit': 'डेबिट',
  'Balance': 'शेष',
  'Fetching data...': 'डेटा प्राप्त किया जा रहा है...',
  'REGION Statistics': 'क्षेत्र के आँकड़े',
  'ZONE Statistics': 'जोन के आँकड़े',
  'CHURCH Statistics': 'चर्च के आँकड़े',
  '* All the sponsorship will be In active': '* सभी प्रायोजन निष्क्रिय हो जाएंगे',
  'Search Staff': 'कर्मचारी खोजें',
  'Total Payroll Exp': 'कुल पेरोल व्यय',
  'Total Additional': 'कुल अतिरिक्त',
  'Show All Church List': 'सभी चर्च सूची देखें',
  'No fields added yet. Select from the top tags to add fields.': 'अभी तक कोई फ़ील्ड नहीं जोड़ी गई है। फ़ील्ड जोड़ने के लिए शीर्ष टैग से चुनें।',
  'Flow Action': 'प्रवाह क्रिया',
  'Select Action Type': 'क्रिया प्रकार चुनें',
  'Default Action:': 'डिफ़ॉल्ट क्रिया:',
  'Please Make sure all are Valid': 'कृपया सुनिश्चित करें कि सभी मान्य हैं',
  'Manage Gift': 'उपहार प्रबंधित करें',
  'Update ROle Details': 'भूमिका विवरण अपडेट करें',
  'Add New Role': 'नई भूमिका जोड़ें',
  'Search Member to add': 'जोड़ने के लिए सदस्य खोजें',
  'Search Staff to add as member': 'सदस्य के रूप में जोड़ने के लिए कर्मचारी खोजें',
  'Clear All': 'सभी साफ़ करें',
  'Manage Registration': 'पंजीकरण प्रबंधित करें',
  'Email Address:': 'ईमेल पता:',
  'Mobile No:': 'मोबाइल नंबर:',
  'Date Of Birth:': 'जन्म तिथि:',
  'Address:': 'पता:',
  'Birth Date:': 'जन्म तिथि:',
  'Permanent Address:': 'स्थायी पता:',
  'Family Image:': 'परिवार की छवि:',
  'Spouse Info': 'पति/पत्नी की जानकारी',
  'No Spouse Details': 'कोई पति/पत्नी का विवरण नहीं',
  'Others Info': 'अन्य जानकारी',
  'Comment': 'टिप्पणी',
  'Medical Info': 'चिकित्सा जानकारी',
  'Bank Details': 'बैंक विवरण',
  'Support Documents': 'सहायक दस्तावेज',
  'Years Of Exp Payroll': 'पेरोल अनुभव के वर्ष',
  'Years': 'साल',
  'Additional Experience': 'अतिरिक्त अनुभव',
  '* All the designation and sponsorship will be': '* सभी पद और प्रायोजन',
  'Staff is not active now': 'कर्मचारी अभी सक्रिय नहीं है',
  'Loading notice data...': 'सूचना डेटा लोड हो रहा है...',
  'Multilingual Content': 'बहुभाषी सामग्री',
  'Published': 'प्रकाशित',
  'Draft': 'ड्राफ्ट',
  'Title (English)': 'शीर्षक (अंग्रेजी)',
  'Content (English)': 'सामग्री (अंग्रेजी)',
  'Targeting & Settings': 'लक्ष्यीकरण और सेटिंग्स',
  'Save Notice': 'सूचना सहेजें',
  'Form Structure': 'फॉर्म संरचना',
  'Fields': 'क्षेत्र',
  'Column:': 'कॉलम:',
  'Not Access to Approve this Child.': 'इस बच्चे को अनुमति देने की पहुंच नहीं है।',
  'To select the Staff to allotment': 'आवंटन के लिए कर्मचारी का चयन करना',
  'Parent Aadhar': 'अभिभावक आधार',
  'OR': 'या',
  'loading...': 'लोड हो रहा है...',
  'Table of Contents': 'विषय-सूची',
  'Select a Document to View': 'देखने के लिए एक दस्तावेज़ चुनें',
  'Policy': 'नीति',
  'Select a section from the table of contents to begin reading.': 'पढ़ना शुरू करने के लिए विषय-सूची से एक अनुभाग चुनें।',
  'Email already exists': 'ईमेल पहले से मौजूद है',
  'Aadhaar Number already exists': 'आधार नंबर पहले से मौजूद है',
  'PAN Number already exists': 'पैन नंबर पहले से मौजूद है',
  'Mobile Number Exists': 'मोबाइल नंबर मौजूद है'
};

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  private currentLang = signal<'en' | 'ta' | 'hi'>('en');

  constructor() {
    const saved = localStorage.getItem('app-lang') as 'en' | 'ta' | 'hi';
    if (saved) this.currentLang.set(saved);
  }

  setLanguage(lang: 'en' | 'ta' | 'hi') {
    this.currentLang.set(lang);
    localStorage.setItem('app-lang', lang);
  }

  getLanguage() {
    return this.currentLang();
  }

  translate(key: string): string {
    const lang = this.currentLang();
    if (lang === 'en') return key;

    const dict = lang === 'ta' ? TAMIL_DICT : HINDI_DICT;
    return dict[key] || key; // Auto-translate fallback
  }
}
